import * as React from 'react'
import ClickOutside from 'react-click-outside'
import {connect} from 'react-redux'
import {Nav, Navbar, NavbarBrand} from 'reactstrap'
import * as redux from 'redux'
import * as Router from '../../router'
import * as Link from '../link'
import './styles.css'
import * as UserMenu from './user-menu'

interface DispatchProps {
  push: (href: string) => redux.Action,
  closeMenu: () => UserMenu.ToggleUserMenuAction,
}
type Props = DispatchProps
export const RasaMenuComponent = ({push, closeMenu}: Props) => <Navbar className="rasa-menu" expand>
  <NavbarBrand onClick={Link.preventDefaultThen(() => push('/'))} href="/">
    <img src="https://image-api.rasa.io/image/rasa-templates/path/rasa/logo_simplified.png?h=30" />
  </NavbarBrand>
  <Nav className="user-nav">
    <ClickOutside onClickOutside={closeMenu}>
      <UserMenu.UserMenuConnected />
    </ClickOutside>
  </Nav>
</Navbar>

export const RasaMenu = connect(
  null,
  {
    closeMenu: UserMenu.clickOutside,
    push: Router.push,
  },
)(RasaMenuComponent)



// WEBPACK FOOTER //
// ./src/components/menu/component.tsx